import "./Landing.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Logo from "../../assets/imgs/logo.svg";
import SmallLogo from "../../assets/imgs/small-logo.svg";
import FamilyRight from "../../assets/imgs/family-right.svg";
import HealthRight from "../../assets/imgs/health-right.svg";
import CivilRight from "../../assets/imgs/civil-right.svg";
import ConsumerLaw from "../../assets/imgs/consumerlaw.svg";
import AboutMeBanner from "../../assets/imgs/about-me-banner.svg";
import AboutMeSmallBanner from "../../assets/imgs/about-me-small-banner.svg";
import AboutUsBanner from "../../assets/imgs/about-us-banner.svg";
import AboutUsSmallBanner from "../../assets/imgs/about-us-small-banner.svg";
import LuisRicardoAvatar from "../../assets/imgs/luis-ricardo-avatar.svg";
import MarianaFalcaoAvatar from "../../assets/imgs/mariana-falcao-avatar.svg";
import AmandaTavaresAvatar from "../../assets/imgs/amanda-tavares-avatar.svg";
import ContactBanner from "../../assets/imgs/contact-banner.svg";
import ContactSmallBanner from "../../assets/imgs/contact-small-banner.svg";
import WhatsappIcon from "../../assets/imgs/whatsapp-icon.png";

import DefaultButton from "../../components/DefaultButton/DefaultButton";

import React, { useEffect } from "react";


const Menu = ({
  servicesRef,
  aboutUsRef,
  contactRef
}) => {
  const currLogo = window.innerWidth > 768 ? Logo : SmallLogo;

  const handleScrollToRef = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  }

  return <div className="menu">
    <a href="#" className="menu__logo">
      <img src={currLogo} alt="logo" className="menu__logo-img" />
    </a>
    <div className="menu__items">
      <a
        href="javascript:;"
        className="menu__item"
        onClick={() => handleScrollToRef(servicesRef)}
      >
        Serviços
      </a>
      <a
        href="javascript:;"
        className="menu__item"
        onClick={() => handleScrollToRef(aboutUsRef)}
      >
        Sobre Nós
      </a>
      <a
        href="javascript:;"
        className="menu__item"
        onClick={() => handleScrollToRef(contactRef)}
      >
        Contato
      </a>
    </div>
    <div className="menu__contact">
      <DefaultButton
        title="Fale conosco"
        onClick={() => {
          handleScrollToRef(contactRef);
        }}
        type="primary"
        style="menu__contact-button"
      />
    </div>
  </div>
}

const Presentation = () => {
  return (
    <div className="presentation">
      <div className="presentation__title">
        <h1>ADVOCACIA ESPECIALIZADA EM DIREITO DE FAMÍLIA E SAÚDE</h1>
      </div>
      <div className="presentation__description">
        <p>Oferecemos soluções jurídicas personalizadas para atender às necessidades dos nossos clientes com atenção, cuidado e profissionalismo. Nosso compromisso é garantir um atendimento humanizado e eficiente, sempre em busca dos melhores resultados.</p>
      </div>
    </div>
  )
}

const Services = () => {
  const items = [
    {
      logo: FamilyRight,
      title: "Direito Das Famílias e Sucessões",
      description: "Nossa equipe especializada auxilia em questões como Divórcio, Guarda de filhos, Pensão alimentícia, Partilha de bens, Regime de bens e Testamentos e inventários. Com uma abordagem estratégica e sensível, buscamos sempre as melhores soluções para nossos clientes, priorizando a proteção dos laços familiares e seus direitos."
    },
    {
      logo: HealthRight,
      title: "Direito à Saúde",
      description: "Atuamos na defesa dos direitos dos pacientes e na garantia do acesso à saúde, oferecendo suporte jurídico para Erros Médicos e Negligência Hospitalar, Cobertura negada por planos de saúde, Tratamentos e medicamentos recusados pelo SUS ou convênios e Demandas contra operadoras de planos de saúde. Nosso objetivo é assegurar que você tenha acesso aos cuidados de saúde necessários e que seus direitos sejam respeitados.",
    },
    {
      logo: CivilRight,
      title: "Direito Civil",
      description: "Prestamos assessoria em diversas questões jurídicas, incluindo Disputas Contratuais, Responsabilidade Civil, Direitos do Consumidor e Indenizações. Com experiência e comprometimento, buscamos as melhores soluções para proteger os interesses dos nossos clientes.",
    },
    {
      logo: ConsumerLaw,
      title: "Direito do Consumidor",
      description: "Oferecemos orientação e representação jurídica em casos de Cobranças Indevidas, Produtos com Defeito, Descumprimento de Oferta, Negativação Indevida, Problemas com Serviços e Indenizações por Danos Materiais e Morais. Trabalhamos com dedicação para assegurar que os direitos dos consumidores sejam respeitados e que os prejuízos sofridos sejam devidamente reparados.",
    }
  ]

  return (
    <div className="services">
      <div className="services__title">
        <h1>AREAS DE ATUAÇÃO</h1>
      </div>
      <div className="services__items">
        {items.map((item, index) => (
          <div className="services__item">
            <div className="services__item-card-logo">
              <img src={item.logo} alt="logo" className="services__item-card-logo-img" />
            </div>
            <div className="services__item-content">
              <div className="services__item-content__title">
                <h2>{item.title}</h2>
              </div>
              <div className="services__item-content__description">
                <p>{item.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const AboutUs = () => {
  const [aboutMeBanner, setAboutMeBanner] = React.useState(window.innerWidth > 900 ? AboutMeBanner : AboutMeSmallBanner);
  const [aboutUsBanner, setAboutUsBanner] = React.useState(window.innerWidth > 900 ? AboutUsBanner : AboutUsSmallBanner);

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 900) {
        setAboutMeBanner(AboutMeBanner);
      } else {
        setAboutMeBanner(AboutMeSmallBanner);
      }

      if (window.innerWidth > 500) {
        setAboutUsBanner(AboutUsBanner);
      } else {
        setAboutUsBanner(AboutUsSmallBanner);
      }
    })
  }, []);

  return (
    <div className="about">
      <div className="about-us">
        <div className="about-us__content">
          <div className="about-us__content__title">
            <h2>Sobre Nós</h2>
          </div>
          <div className="about-us__content__description">
            <p>Com ampla experiência e um histórico de resultados positivos, nosso escritório se destaca pela excelência na advocacia e no atendimento personalizado. Atuamos com ética, compromisso e estratégia, sempre focados em oferecer as melhores soluções jurídicas para nossos clientes. Nosso diferencial é o atendimento próximo e humanizado, garantindo transparência, segurança e um suporte jurídico eficaz. Contamos com uma equipe altamente qualificada, especializada em Direito de Família, Sucessões, Saúde e Civil, sempre buscando a melhor resolução para cada caso. Localizados no Jardim Paulista, atendemos com profissionalismo e dedicação, proporcionando um serviço jurídico sólido, confiável e comprometido com a defesa dos direitos e interesses dos nossos clientes.</p>
          </div>
        </div>
        <div className="about-us__banner">
          <img src={aboutUsBanner} alt="banner" className="about-us__banner-img" />
        </div>
      </div>
      <div className="about-me">
        <div className="about-me__banner">
          <img src={aboutMeBanner} alt="banner" className="about-me__banner-img" />
        </div>
        <div className="about-me__content">
          <div className="about-me__content__title">
            <h2>SOBRE A PROFISSIONAL</h2>
          </div>
          <div className="about-me__content__description">
            <p>Rafaela Braga Del Nero é advogada especialista em Direito de Família e Sucessões, formada pela PUC - São Paulo, com ampla experiência na área. Como fundadora e líder do escritório, destaca-se pelo atendimento próximo, humanizado e pela busca das melhores soluções jurídicas para cada cliente. Seja qual for sua necessidade, conte conosco para representá-lo com seriedade, ética e comprometimento.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const Testimonials = () => {
  const items = [
    {
      avatar: LuisRicardoAvatar,
      name: "Luis Ricardo",
      message: "”Excelente atendimento! Fui muito bem orientado e consegui resolver meu caso de forma rápida e eficaz. Recomendo a todos.”"
    },
    {
      avatar: MarianaFalcaoAvatar,
      name: "Mariana Falcão",
      message: "“Profissionais extremamente competentes e atenciosos. Estou muito satisfeita com o resultado do meu processo de divórcio.”",
    },
    {
      avatar: AmandaTavaresAvatar,
      name: "Amanda Tavares",
      message: "“O suporte jurídico que recebi foi essencial para garantir meus direitos como paciente. Sou muito grato pela dedicação e expertise da equipe.”",
    }
  ]

  return (
    <div className="testimonials">
      <div className="testimonials__title">
        <h1>Depoimentos De Clientes</h1>
      </div>
      <div className="testimonials__items">
        {items.map((item, index) => (
          <div className="testimonials__item">
            <div className="testimonials__item-message">
              <p>{item.message}</p>
            </div>
            <div className="testimonials__item-person">
              <div className="testimonials__item-person__avatar">
                <img src={item.avatar} alt="avatar" className="testimonials__item-person-avatar-img" />
              </div>
              <div className="testimonials__item-person__name">
                <h3>{item.name}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

const Contact = () => {
  const [contactBanner, setContactBanner] = React.useState(window.innerWidth > 900 ? ContactBanner : ContactSmallBanner);
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");

  const formatMessage = (message) => {
    return message.split("\n").join("%0D%0A");
  }

  useEffect(() => {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1100) {
        setContactBanner(ContactBanner);
      } else {
        setContactBanner(ContactSmallBanner);
      }
    })
  }, []);

  return (
    <div className="contact">
      <div className="contact__header">
        <div className="contact__title">
          <h1>Estamos Aqui Para Ajudar</h1>
        </div>
        <div className="contact__description">
          <h2>Você pode entrar em contato conosco a qualquer momento através de contato@bragadelnero.com</h2>
        </div>
      </div>
      <div className="contact__content">
        <div className="contact__form">
          <div className="contact__form-item">
            <div className="contact__form__title">
              <p>Nome</p>
            </div>
            <div className="contact__form__input">
              <input 
                type="text"
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="contact__form-item">
            <div className="contact__form__title">
              <p>Email</p>
            </div>
            <div className="contact__form__input">
              <input 
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="contact__form-item">
            <div className="contact__form__title">
              <p>Mensagem</p>
            </div>
            <div className="contact__form__input">
              <textarea 
                placeholder="Descreva sua mensagem..."
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
          </div>
          <div className="contact__form__button">
            <DefaultButton
              title="Enviar mensagem"
              onClick={() => {
                window.location.href = `mailto:contato@bragadelnero.com?subject=Contato Através do Site&body=Nome: ${name}%0D%0AEmail: ${email}%0D%0A%0D%0A${formatMessage(message)}`
              }}
              type="primary"
              style="contact__form__button"
              disabled={name === "" || email === "" || message === ""}
            />
          </div>
        </div>
        <div className="contact__banner">
          <img src={contactBanner} alt="banner" className="contact__banner-img" />
        </div>
      </div>
    </div>
  )
}

const Footer = () => {
  return (
    <div className="footer">
      <a href="#" className="footer__logo">
        <img src={SmallLogo} alt="logo" className="footer__logo-img" />
      </a>
      <div className="footer__corp">
        <p>© 2025 Todos os direitos reservados</p>
      </div>
    </div>
  )
};

const Landing = () => {
  const [servicesRef, setServicesRef] = React.useState(null);
  const [aboutUsRef, setAboutUsRef] = React.useState(null);
  const [contactRef, setContactRef] = React.useState(null);
  const servicesDynamicRef = React.useRef(null);
  const aboutUsDynamicRef = React.useRef(null);
  const contactDynamicRef = React.useRef(null);

  React.useEffect(() => {
    setServicesRef(servicesDynamicRef);
    setAboutUsRef(aboutUsDynamicRef);
    setContactRef(contactDynamicRef);
  }, []);

  return (
    <>
      <div className="top">
        <Menu servicesRef={servicesRef} aboutUsRef={aboutUsRef} contactRef={contactRef} />
        <Presentation />
      </div>
      <div ref={servicesDynamicRef}>
        <Services ref={servicesDynamicRef}/>
      </div>
      <div ref={aboutUsDynamicRef}>
        <AboutUs />
      </div>
      <div >
        <Testimonials />
      </div>
      <div ref={contactDynamicRef}>
        <Contact />
      </div>
      <Footer />
      <a href="https://wa.me/1123651907" className="whatsapp-section" target="_blank">
        <img src={WhatsappIcon} alt="whatsapp" className="whatsapp-icon" />
      </a>
    </>
  )
}

export default Landing;

Landing.propTypes = {};
